import * as Yup from 'yup'

const reference = Yup.object({
    first_name:Yup.string().required('INPUT.VALIDATION.FIRSTNAME'),
    last_name:Yup.string().required('INPUT.VALIDATION.LASTNAME'),
    email:Yup.string().email('CLEANER.REFERENCE.INPUT.EMAIL').required('INPUT.VALIDATION.EMAIL'),
    mobile_number:Yup.string().required("INPUT.VALIDATION.MOBILENUMBER"),
    visible_to_employer:Yup.bool()
})
export default reference;